import { render, staticRenderFns } from "./DevColorContextMenu.vue?vue&type=template&id=3d9b18ba&scoped=true"
import script from "./DevColorContextMenu.vue?vue&type=script&lang=js"
export * from "./DevColorContextMenu.vue?vue&type=script&lang=js"
import style0 from "./DevColorContextMenu.vue?vue&type=style&index=0&id=3d9b18ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9b18ba",
  null
  
)

export default component.exports